import { environment } from "src/environments/environment";

export class Global {
   public static url = environment.apiURI;
  public static baseUrl = Global.url + '/api/v0';
}
